import * as React from "react";
import BODebounceInput from "app/components/BOComponents/BODebounceInput";
import WalletContainer from "app/components/AppComponents/SnapScan/Wallet/Wallet.Container";

import { groupAuth } from "app/utils/authGroups";
import AddWallet from "app/components/AppComponents/SnapScan/Wallet/Wallet.UpdateWallet";

import { Grid } from "@material-ui/core";

const hasAccessToWalletAdmin = groupAuth.hasAccessGroup(["Wallet/Admin"]);

type State = {
  search: string;
};

export default class WalletList extends React.Component<any, State> {
  state = {
    search: ""
  };

  componentDidMount() {
    this.props.setHeader({
      title: `Wallet > List`,
      description: "View available wallets or vouchers"
    });
  }

  render() {
    return (
      <section className="padded">
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <BODebounceInput
            minLength={2}
            debounceTimeout={300}
            value={this.state.search}
            placeholder={
              this.props.vouchering ? "Search Vouchering" : "Search Wallet"
            }
            onChange={search => {
              this.setState({ search });
            }}
          />

          {hasAccessToWalletAdmin && !this.props.vouchering && (
            <AddWallet type={"add"} />
          )}
        </Grid>
        <WalletContainer
          name={"wallet.list"}
          search={this.state.search}
          vouchering={this.props.vouchering}
        />
      </section>
    );
  }
}
